













import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import MediaListItem from '@/modules/media/components/shared/MediaListItem.vue'
import { Emit, ModelSync, Prop } from 'vue-property-decorator'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'

@Component({
  components: {
    MediaListItem
  }
})
export default class MediaList extends Vue {
  @ModelSync('value', 'change') medias: Array<File | MediaResourceModel>

  @Prop({ default: true }) deletable: boolean
  @Prop({ default: 'col-auto' }) itemClasses: string | string[] | Record<string, boolean>

  @Emit()
  protected remove(index) {
    const removedMedia = this.medias[index]
    this.medias = this.medias.filter((media, idx) => index !== idx)
    return removedMedia
  }
}
